import React from 'react'
import {Link} from 'react-router-dom'

function TeamsSmallCard({id,imgTeam,teamName,idLeague}) {
  return (
    <div className='w-full min-h-[100px] flex max-h-[50px] border  border-gray-400 rounded-lg pl-2  '>

     <div className=' basis-1/4 flex justify-start items-center '>
      <img className='h-[70px] ' src={imgTeam}/>
      </div>

      <Link to={`/teams/${idLeague}/${id}`}  className='basis-2/4 flex flex-col flex justify-center items-center text-xs font-extrabold '>
        {teamName}
      </Link>


     

    </div>
  )
}

export default TeamsSmallCard
